<script>
  /**
   * A tag or badge containing a very short label (e.g. "Editor’s Picks"). Has a colored background.
   */
  export default {
    props: {
      /** The tag’s label. */
      label: {
        type: String,
        default: '',
      },
      /** The tag’s background color. */
      color: {
        type: String,
        default: 'gray-opacity68',
        validator: (value) =>
          [
            'gray-opacity68',
            'primary',
            'sunshine',
            'spring',
            'summer',
            'fall',
            'dawn-lt2',
          ].includes(value),
      },
      /** The tag’s text color. */
      textColor: {
        type: String,
        default: 'white',
        validator: (value) => ['white', 'black'].includes(value),
      },
    },
  }
</script>

<template>
  <!-- for purgecss: bg-gray-opacity68 bg-primary bg-sunshine bg-spring bg-summer bg-fall bg-dawn-lt2 text-white text-black -->
  <div
    :class="`pt-3px pb-2px px-3px font-semibold text-2xs leading-none uppercase tracking-wide overflow-hidden ellipsis bg-${color} text-${textColor}`"
  >
    <!-- @slot The tag's content. Takes precedence over the `label` prop. -->
    <slot>
      {{ label }}
    </slot>
  </div>
</template>
